import * as React from 'react';
import { pipe } from 'fp-ts/lib/function';
import * as Op from 'monocle-ts/lib/Optional';

export interface LabelStyle {
    labelWidth: number,
    labelHeight: number,
}

export interface FormStyleContext extends Partial<LabelStyle> {}

export interface FormConfig extends Partial<LabelStyle> {}

const FormStyleContext = React.createContext<FormStyleContext>({});

export const FormStyle: React.FunctionComponent<FormConfig> = ({ children, labelWidth, labelHeight }) => {
    return (
        <FormStyleContext.Provider value={{
            labelWidth,
            labelHeight,
        }}>
            {children}
        </FormStyleContext.Provider>
    );
}

export const useFormStyleContext = () => {
    const ctx = React.useContext(FormStyleContext);

    return ctx;
}


const safeTakeFromContext = 
    (prop: keyof FormStyleContext) =>
        pipe(
            Op.id<FormStyleContext>(), 
            Op.prop(prop),
            Op.fromNullable,
        );

export const getLabelWidth = safeTakeFromContext('labelWidth');
export const getLabelHeight = safeTakeFromContext('labelHeight');
